module.exports = __webpack_public_path__ + "media/images/pic/teachers/hiroko-fujii-ff40bc0623436c53d9ea5c0bd4da9175.png";